import { Outlet } from 'react-router';

import { useFoTheme } from './useFoTheme';

/** 셸 없는 중앙정렬 레이아웃 — 전환 전용 화면(SSO 콜백)용. */
export function FoBlankLayout() {
  useFoTheme();
  return (
    <div className="flex min-h-screen items-center justify-center bg-background px-6 py-12">
      <Outlet />
    </div>
  );
}
